export const PROFILE_SET_OVERVIEW = 'PROFILE_SET_OVERVIEW';
export const PROFILE_SET_INITIAL_STATE = 'PROFILE_SET_INITIAL_STATE'
export const PROFILE_SET_MY_MODULES = 'PROFILE_SET_MY_MODULES'
